import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { AclService } from 'src/app/shared/services/acl.service';
import { AuthService } from 'src/app/shared/services/auth.service';

export interface UserData {
    id: string,
    imageUrl: string,
    lineManager: any,
    manager: boolean,
    name: string,
    username: string
}

@Injectable({
    providedIn: 'root' 
})

export class AclGuard  {
    constructor(private router: Router, private route: ActivatedRoute,
        private AuthService: AuthService, private aclService: AclService) {
    }

    async canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot) {

        const currentUser: UserData = (await this.AuthService.getUserData().toPromise()).data;
        const accessType = next.data.access;
        
        const userAllowed = currentUser && currentUser.manager;
        const existRoute = accessType && accessType.length !== 0;
        const roleAllowed = await this.aclService.can(accessType);

        if (!existRoute || (!userAllowed && !roleAllowed))
        {
            this.router.navigate(['/dashboard'], { queryParams: { returnUrl: state.url }});
            return false;
        }
        return true;
    }
}